<template>
  <div class="user">
    <div class="user-active" v-if="connected" :title="profile.email">
      <span class="header-item">
        <img src="../../assets/icons/user.png" />
      </span>
      <span class="header-item">
        <slot>{{ profile.displayName || profile.email }}</slot>
      </span>
      <span class="header-item">
        <button class="gm-button red small" @click="logout">{{ $t("message.pageHeader.logout") }}</button>
      </span>
    </div>
    <div class="user-inactive" v-else>
      <span class="header-item lock-icon">
        <router-link to="login">{{ $t("message.pageHeader.login") }}</router-link>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      connected: (state) => state.auth.connected,
      profile: (state) => state.auth.profile
    })
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
      this.$store.state.user.unsubscribeFn()
    }
  }
}
</script>

<style lang="scss">
.user {
  display: flex;
  align-items: center;
  margin-left: 48px;
  &-active {
    display: flex;
    align-items: center;
  }
}
.user-icon {
  margin-left: 20px;
  width: 24px;
  height: 24px;
  border: none;
  background-size: 19.5px 22px;
  background-position-y: center;
  background-repeat: no-repeat;
  background-image: url('../../assets/icons/user.png');
}
.lock-icon.header-item {
  padding-left: 20px;
  margin-left: 20px;
  border: none;
  background-size: 13px 16px;
  background-position-y: center;
  background-position-x: left;

  background-repeat: no-repeat;
  background-image: url('../../assets/icons/Lock.png');
}
</style>
